import { defineComponent, ref, toRefs, computed, withDirectives, openBlock, createElementBlock, normalizeStyle, normalizeClass, vModelDynamic, renderSlot, watch, resolveComponent, createVNode, createSlots, withCtx, createTextVNode, toDisplayString, createElementVNode, vShow, createBlock, createCommentVNode, Fragment, getCurrentInstance, resolveDirective, withModifiers, renderList } from 'vue';
import { r as re, T, F as Fs, m as d, y as ys, s, g as c, n as ne, $ as $s, d as ds } from '../OrAutocompleteV3-508d99c0.js';
import { l } from '../OrEditorTabsV3-4047a163.js';
import { useFocus } from '@vueuse/core';
import { OrTagsV3 as script$5, TagsOverflow } from '../or-tags-v3/index.js';
import { OrTooltipV3 as script$6 } from '../or-tooltip-v3/index.js';
import { OrCheckboxV3 as script$7 } from '../or-checkbox-v3/index.js';
import { OrErrorV3 as script$8 } from '../or-error-v3/index.js';
import { OrExpansionPanelV3 as script$9 } from '../or-expansion-panel-v3/index.js';
import { OrHintV3 as script$a } from '../or-hint-v3/index.js';
import { OrIconV3 as script$b } from '../or-icon-v3/index.js';
import { OrIconButtonV3 as script$c } from '../or-icon-button-v3/index.js';
import { OrInputV3 as script$d } from '../or-input-v3/index.js';
import { OrInputBoxV3 as script$e, InputBoxVariant } from '../or-input-box-v3/index.js';
import { OrLabelV3 as script$f } from '../or-label-v3/index.js';
import { OrMenuItemV3 as script$g } from '../or-menu-item-v3/index.js';
import { OrPopoverV3 as script$h } from '../or-popover-v3/index.js';
import { OrLoaderV3 as script$i } from '../or-loader-v3/index.js';
import '@onereach/styles/screens.json';
import '@onereach/styles/tailwind.config.json';
import 'lodash/get';
import 'lodash/isElement';
import '../or-tag-input-v3/index.js';
import '../OrInlineInputV3-46210775.js';
import '../or-inline-input-box-v3/index.js';
import '../or-text-v3/index.js';
import '../or-tag-v3/index.js';
import '../or-menu-v3/index.js';
import '@floating-ui/dom';
import '../or-bottom-sheet-v3/index.js';
import '../or-overlay-v3/index.js';
import '../or-teleport-v3/index.js';
import '../or-button-v3/index.js';

const SelectControlInput = [
// Base
'appearance-none',
// Typography
'typography-inherit',
// Theme (placeholder)
'placeholder:theme-foreground-outline', 'dark:placeholder:theme-foreground-outline-dark', 'theme-background-transparent', 'outline-none'];

var script$4 = defineComponent({
  name: 'OrSelectControlInput',
  model: {
    prop: 'modelValue',
    event: 'update:modelValue'
  },
  props: {
    modelValue: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],
  expose: ['root', 'focus', 'focused'],
  setup(props, context) {
    // Refs
    const root = ref();
    // Props
    const {
      placeholder,
      modelValue
    } = toRefs(props);
    // State
    const proxyModelValue = re(modelValue, context.emit);
    const {
      focused
    } = useFocus(root);
    // Styles
    const controlStyles = computed(() => [...SelectControlInput]);
    const controlInlineStyles = computed(() => {
      var _a;
      const chars = proxyModelValue.value.length > 0 ? proxyModelValue.value.length : (_a = placeholder.value) === null || _a === void 0 ? void 0 : _a.length;
      return {
        width: `${Math.max(chars + 1 || 0, 2)}ch`
      };
    });
    // Methods
    function focus() {
      focused.value = true;
    }
    return {
      root,
      proxyModelValue,
      controlStyles,
      controlInlineStyles,
      focused,
      focus
    };
  }
});

const _hoisted_1$4 = ["placeholder", "readonly", "disabled"];
function render$4(_ctx, _cache, $props, $setup, $data, $options) {
  return withDirectives((openBlock(), createElementBlock("input", {
    ref: 'root',
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.proxyModelValue = $event),
    style: normalizeStyle(_ctx.controlInlineStyles),
    class: normalizeClass(_ctx.controlStyles),
    type: 'text',
    placeholder: _ctx.placeholder,
    readonly: _ctx.readonly,
    disabled: _ctx.disabled,
    autocomplete: 'off',
    minlength: undefined,
    maxlength: undefined
  }, null, 14 /* CLASS, STYLE, PROPS */, _hoisted_1$4)), [[vModelDynamic, _ctx.proxyModelValue]]);
}

script$4.render = render$4;
script$4.__file = "src/components/or-select-v3/partials/or-select-control-input/OrSelectControlInput.vue";

const SelectPlaceholder = [
// Interactivity
'interactivity-default',
// Typography
'typography-inherit truncate',
// Theme
'theme-foreground-outline', 'dark:theme-foreground-outline-dark'];

var script$3 = defineComponent({
  name: 'OrSelectPlaceholder',
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },
  expose: ['root'],
  setup() {
    // Refs
    const root = ref();
    // Styles
    const rootStyles = computed(() => ['or-select-placeholder-v3', ...SelectPlaceholder]);
    return {
      root,
      rootStyles
    };
  }
});

const _hoisted_1$3 = ["disabled"];
function render$3(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    ref: 'root',
    class: normalizeClass(_ctx.rootStyles),
    disabled: _ctx.disabled
  }, [renderSlot(_ctx.$slots, "default")], 10 /* CLASS, PROPS */, _hoisted_1$3);
}

script$3.render = render$3;
script$3.__file = "src/components/or-select-v3/partials/or-select-placeholder/OrSelectPlaceholder.vue";

const SelectMultipleControlRoot = [
// Layout
'layout-row', 'w-full'];

var script$2 = defineComponent({
  name: 'OrSelectMultipleControl',
  components: {
    OrSelectPlaceholder: script$3,
    OrSelectControlInput: script$4,
    OrTags: script$5
  },
  model: {
    prop: 'modelValue',
    event: 'update:modelValue'
  },
  props: {
    modelValue: {
      type: String,
      default: ''
    },
    model: {
      type: undefined,
      default: () => []
    },
    options: {
      type: Array,
      default: () => []
    },
    overflow: {
      type: String,
      default: () => TagsOverflow.Hidden
    },
    placeholder: {
      type: String,
      default: undefined
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    enableSearch: {
      type: Boolean,
      default: false
    },
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'reset'],
  expose: ['root', 'focus', 'focused'],
  setup(props, context) {
    // Refs
    const root = ref();
    const searchControl = ref();
    const tags = ref();
    // Props
    const {
      modelValue,
      model,
      options,
      overflow
    } = toRefs(props);
    // State
    const searchModelValue = re(modelValue, context.emit);
    const focused = computed(() => {
      var _a;
      return (_a = searchControl.value) === null || _a === void 0 ? void 0 : _a.focused;
    });
    // Styles
    const rootStyles = computed(() => ['or-select-multiple-control-v3', ...SelectMultipleControlRoot]);
    // Computed
    const value = computed(() => T(model.value) ? [] : Fs(model.value));
    const isEmpty = computed(() => value.value.length === 0);
    const selection = computed(() => {
      if (model.value === undefined || model.value === null) {
        return [];
      }
      return value.value.map(value => options.value.find(option => d(option.value, value))).filter(value => !!value).map(option => ({
        value: option.value,
        label: option.label,
        tagProps: option.disabled && {
          disabled: option.disabled
        }
      }));
    });
    watch(selection, (items, prevItems) => {
      if (items.length != prevItems.length && overflow.value === TagsOverflow.Scroll && tags.value) {
        tags.value.scrollToEnd();
      }
    });
    // Methods
    function focus() {
      if (searchControl.value) {
        searchControl.value.focus();
      }
    }
    return {
      root,
      tags,
      rootStyles,
      searchControl,
      searchModelValue,
      isEmpty,
      selection,
      value,
      focus,
      focused
    };
  }
});

const _hoisted_1$2 = {
  class: "inline-flex w-fit max-w-full"
};
function render$2(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrSelectControlInput = resolveComponent("OrSelectControlInput");
  const _component_OrTags = resolveComponent("OrTags");
  const _component_OrSelectPlaceholder = resolveComponent("OrSelectPlaceholder");
  return openBlock(), createElementBlock("div", {
    ref: 'root',
    class: normalizeClass(_ctx.rootStyles)
  }, [withDirectives(createVNode(_component_OrTags, {
    ref: 'tags',
    items: _ctx.selection,
    class: "grow",
    disabled: _ctx.disabled,
    "tag-props": {
      variant: _ctx.readonly || _ctx.disabled ? 'tag' : 'reset',
      disabled: _ctx.disabled
    },
    overflow: _ctx.overflow,
    onReset: _cache[1] || (_cache[1] = $event => _ctx.$emit('reset', $event))
  }, createSlots({
    tag: withCtx(({
      item
    }) => [renderSlot(_ctx.$slots, "tag", {
      item: item
    }, () => [createTextVNode(toDisplayString(item.label), 1 /* TEXT */)])]),
    _: 2 /* DYNAMIC */
  }, [_ctx.enableSearch ? {
    name: "tail",
    fn: withCtx(() => [createElementVNode("div", _hoisted_1$2, [createVNode(_component_OrSelectControlInput, {
      ref: 'searchControl',
      modelValue: _ctx.searchModelValue,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.searchModelValue = $event),
      placeholder: _ctx.isEmpty ? _ctx.placeholder : '',
      readonly: _ctx.readonly,
      disabled: _ctx.disabled
    }, null, 8 /* PROPS */, ["modelValue", "placeholder", "readonly", "disabled"])])]),
    key: "0"
  } : undefined]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["items", "disabled", "tag-props", "overflow"]), [[vShow, !_ctx.isEmpty || _ctx.enableSearch]]), _ctx.isEmpty && !_ctx.enableSearch ? (openBlock(), createBlock(_component_OrSelectPlaceholder, {
    key: 0,
    disabled: _ctx.disabled
  }, {
    default: withCtx(() => [createTextVNode(toDisplayString(_ctx.placeholder), 1 /* TEXT */)]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["disabled"])) : createCommentVNode("v-if", true)], 2 /* CLASS */);
}

script$2.render = render$2;
script$2.__file = "src/components/or-select-v3/partials/or-select-multiple-control/OrSelectMultipleControl.vue";

const SelectSingleControlInput = [
// Layout
'w-full'];

var script$1 = defineComponent({
  name: 'OrSelectSingleControl',
  components: {
    OrSelectPlaceholder: script$3,
    OrSelectControlInput: script$4,
    OrTooltip: script$6
  },
  model: {
    prop: 'modelValue',
    event: 'update:modelValue'
  },
  props: {
    modelValue: {
      type: String,
      default: ''
    },
    model: {
      type: undefined,
      default: undefined
    },
    options: {
      type: Array,
      default: () => []
    },
    placeholder: {
      type: String,
      default: undefined
    },
    disabled: {
      type: Boolean,
      default: false
    },
    enableSearch: {
      type: Boolean,
      default: false
    },
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],
  expose: ['root', 'focus', 'focused'],
  setup(props, context) {
    // Refs
    const root = ref();
    const searchControl = ref();
    const selectionLabelRef = ref();
    const tooltipRef = ref();
    // Props
    const {
      modelValue,
      model,
      options
    } = toRefs(props);
    // State
    const searchModelValue = re(modelValue, context.emit);
    const isEmptyModelValue = computed(() => {
      return ys(model.value);
    });
    const selection = computed(() => {
      return options.value.find(option => d(option.value, model.value));
    });
    const selectionLabel = computed(() => {
      var _a;
      return (_a = selection.value) === null || _a === void 0 ? void 0 : _a.label;
    });
    watch(() => props.isOpen, () => {
      var _a;
      (_a = tooltipRef.value) === null || _a === void 0 ? void 0 : _a.close();
    });
    const focused = computed(() => {
      var _a;
      return (_a = searchControl.value) === null || _a === void 0 ? void 0 : _a.focused;
    });
    const openTooltip = () => {
      if (tooltipRef.value) tooltipRef.value.open();
    };
    const closeTooltip = () => {
      if (tooltipRef.value) tooltipRef.value.close();
    };
    // Styles
    const rootStyles = computed(() => ['or-select-single-control-v3', ...SelectSingleControlInput]);
    // Methods
    function focus() {
      if (searchControl.value) {
        searchControl.value.focus();
      }
    }
    function checkTooltip() {
      if (!selectionLabelRef.value) return; // to prevent fro TS error; normally ref will always be available here since the method is a mouse event callback
      const isContentTruncated = selectionLabelRef.value.scrollWidth > selectionLabelRef.value.clientWidth;
      if (isContentTruncated) openTooltip();
    }
    return {
      root,
      rootStyles,
      searchControl,
      searchModelValue,
      isEmptyModelValue,
      selection,
      selectionLabel,
      focus,
      focused,
      selectionLabelRef,
      tooltipRef,
      openTooltip,
      closeTooltip,
      checkTooltip
    };
  }
});

const _hoisted_1$1 = {
  key: 1,
  class: "flex"
};
function render$1(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrSelectControlInput = resolveComponent("OrSelectControlInput");
  const _component_OrSelectPlaceholder = resolveComponent("OrSelectPlaceholder");
  const _component_OrTooltip = resolveComponent("OrTooltip");
  return openBlock(), createElementBlock("div", {
    ref: 'root',
    class: normalizeClass(_ctx.rootStyles)
  }, [_ctx.isOpen && _ctx.enableSearch ? (openBlock(), createBlock(_component_OrSelectControlInput, {
    key: 0,
    ref: 'searchControl',
    modelValue: _ctx.searchModelValue,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.searchModelValue = $event),
    placeholder: _ctx.isEmptyModelValue ? _ctx.placeholder : _ctx.selectionLabel
  }, null, 8 /* PROPS */, ["modelValue", "placeholder"])) : (openBlock(), createElementBlock(Fragment, {
    key: 1
  }, [_ctx.isEmptyModelValue ? (openBlock(), createBlock(_component_OrSelectPlaceholder, {
    key: 0,
    disabled: _ctx.disabled
  }, {
    default: withCtx(() => [createTextVNode(toDisplayString(_ctx.placeholder), 1 /* TEXT */)]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["disabled"])) : (openBlock(), createElementBlock("div", _hoisted_1$1, [createElementVNode("div", {
    ref: "selectionLabelRef",
    class: "truncate w-full",
    onMouseenter: _cache[1] || (_cache[1] = (...args) => _ctx.checkTooltip && _ctx.checkTooltip(...args)),
    onMouseleave: _cache[2] || (_cache[2] = (...args) => _ctx.closeTooltip && _ctx.closeTooltip(...args))
  }, toDisplayString(_ctx.selectionLabel), 545 /* TEXT, NEED_HYDRATION, NEED_PATCH */), createVNode(_component_OrTooltip, {
    ref: "tooltipRef",
    content: _ctx.selectionLabel,
    trigger: _ctx.selectionLabelRef
  }, null, 8 /* PROPS */, ["content", "trigger"])]))], 64 /* STABLE_FRAGMENT */))], 2 /* CLASS */);
}

script$1.render = render$1;
script$1.__file = "src/components/or-select-v3/partials/or-select-single-control/OrSelectSingleControl.vue";

const Select = [
// Layout
'layout-column',
// Spacing
'gap-xs'];
const SelectControl = [
// Layout
'layout-row', 'w-full',
// Layout (empty)
'empty:hidden',
// Overflow
'overflow-hidden',
// Spacing
'gap-xs',
// Typography
'typography-inherit'];
const SelectSearchControl = [
// Spacing
'!mx-lg md:!-mx-sm+', '!my-sm md:!my-0'];
const SelectDropdown = [
// Overflow
'overflow-y-auto',
// Box
'max-h-[172px]',
// equals 5 items
// Theme
'theme-background-default', 'dark:theme-background-default-dark', 'theme-border-outline border-1', 'dark:theme-border-outline-dark'];
const SelectDropdownDefault = [
// Shape
'rounded-b-md',
// Theme
'!border-t-0'];
const SelectDropdownFlipped = [
// Shape
'rounded-t-md',
// Theme
'!border-b-0'];
const SelectDropdownItem = [
// Typography
'!typography-body-2-regular',
// Padding Override todo: check design
'!py-md md:!pt-[6px] md:!pb-[7px]',
// Typography (selected)
'selected:!typography-body-2-semibold',
// Theme
'!theme-foreground-default dark:!theme-foreground-default-dark'];
const SelectNoSearchResults = [
// Layout
'layout-row justify-center',
// Spacing
'px-md', 'py-md',
// Typography
'typography-caption-regular',
// Theme
'theme-foreground-outline', 'dark:theme-foreground-outline-dark'];
const SelectLoader = [
// Layout
'w-fit',
// Typography
'typography-body-2-regular',
// Theme
'text-outline dark:text-outline-dark'];

var script = defineComponent({
  name: 'OrSelect',
  components: {
    OrCheckbox: script$7,
    OrError: script$8,
    OrExpansionPanel: script$9,
    OrHint: script$a,
    OrIcon: script$b,
    OrIconButton: script$c,
    OrInput: script$d,
    OrInputBox: script$e,
    OrLabel: script$f,
    OrMenuItem: script$g,
    OrPopover: script$h,
    OrSelectMultipleControl: script$2,
    OrSelectSingleControl: script$1,
    OrLoader: script$i
  },
  directives: {
    DropdownClose: s,
    DropdownOpen: c
  },
  model: {
    prop: 'modelValue',
    event: 'update:modelValue'
  },
  props: {
    modelValue: {
      type: undefined,
      default: undefined
    },
    options: {
      type: Array,
      default: () => []
    },
    searchOptions: {
      type: Array,
      default: () => []
    },
    multiple: {
      type: Boolean,
      default: false
    },
    overflow: {
      type: String,
      default: () => TagsOverflow.Hidden
    },
    variant: {
      type: String,
      default: undefined
    },
    size: {
      type: String,
      default: undefined
    },
    anchor: {
      type: Object,
      default: undefined
    },
    label: {
      type: String,
      default: undefined
    },
    placeholder: {
      type: String,
      default: undefined
    },
    hint: {
      type: String,
      default: undefined
    },
    error: {
      type: [String, Boolean],
      default: undefined
    },
    loading: {
      type: Boolean,
      default: false
    },
    loadingText: {
      type: String,
      default: 'Loading'
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    enableSearch: {
      type: Boolean,
      default: false
    },
    enableClear: {
      type: Boolean,
      default: false
    },
    searchFunction: {
      type: Function,
      default: l
    },
    groupByFunction: {
      type: Function,
      default: undefined
    },
    externalControl: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'focus', 'blur', 'search'],
  expose: ['root', 'open', 'close', 'toggle', 'toggleOption', 'popover', 'popoverState'],
  setup(props, context) {
    var _a;
    const currentInstance = getCurrentInstance();
    // Refs
    const root = ref();
    const inputBox = ref();
    const inputBoxRoot = computed(() => {
      var _a;
      return (_a = inputBox.value) === null || _a === void 0 ? void 0 : _a.root;
    });
    const control = ref();
    const multipleControl = ref();
    const singleControl = ref();
    const searchControl = ref();
    const popover = ref();
    const popoverRoot = computed(() => {
      var _a;
      return (_a = popover.value) === null || _a === void 0 ? void 0 : _a.root;
    });
    const popoverState = computed(() => {
      var _a;
      return (_a = popover.value) === null || _a === void 0 ? void 0 : _a.state;
    });
    // Props
    const {
      enableClear,
      enableSearch,
      modelValue,
      multiple
    } = toRefs(props);
    // State
    const controlId = ref((_a = context.attrs.id) !== null && _a !== void 0 ? _a : currentInstance.uid.toString());
    const proxyModelValue = re(modelValue, context.emit);
    const bottomSheetFullscreen = computed(() => {
      var _a, _b;
      return (_b = (_a = popover.value) === null || _a === void 0 ? void 0 : _a.bottomSheet) === null || _b === void 0 ? void 0 : _b.fullscreen;
    });
    const isEmptyModelValue = computed(() => {
      return ys(proxyModelValue.value);
    });
    const showClear = computed(() => {
      return enableClear.value && !isEmptyModelValue.value;
    });
    const focused = computed(() => {
      var _a, _b;
      if (multiple.value) {
        return (_a = multipleControl.value) === null || _a === void 0 ? void 0 : _a.focused;
      } else {
        return (_b = singleControl.value) === null || _b === void 0 ? void 0 : _b.focused;
      }
    });
    const readonly = computed(() => context.attrs.readonly);
    const internalSearchOptions = ref(props.options);
    const resolvedSearchOptions = computed(() => {
      return props.externalControl ? props.searchOptions : internalSearchOptions.value;
    });
    const searchText = ref('');
    watch([() => props.externalControl, searchText, () => props.options], async ([externalControl, searchText, options]) => {
      if (externalControl) {
        context.emit('search', searchText);
      } else {
        internalSearchOptions.value = await props.searchFunction(searchText, options);
      }
    }, {
      deep: true
    });
    const groupedOptions = computed(() => {
      const groupBy = props.groupByFunction;
      if (groupBy) {
        return internalSearchOptions.value.reduce((accumulator, option) => {
          var _a;
          const group = groupBy(option);
          return {
            ...accumulator,
            [group]: [...((_a = accumulator[group]) !== null && _a !== void 0 ? _a : []), option]
          };
        }, {});
      }
      return {
        '': props.options
      };
    });
    // Styles
    const rootStyles = computed(() => ['or-select-v3', ...Select, ...(props.variant === InputBoxVariant.Embedded ? ['grow'] : [])]);
    const controlStyles = computed(() => [...SelectControl]);
    const searchControlStyles = computed(() => [...SelectSearchControl]);
    const dropdownStyles = computed(() => {
      var _a;
      return ['or-select-popover-v3', ...SelectDropdown, ...(((_a = popover.value) === null || _a === void 0 ? void 0 : _a.isFlipped) ? SelectDropdownFlipped : SelectDropdownDefault)];
    });
    const dropdownContainerStyles = computed(() => [isMobile.value ? 'layout-column' : 'contains', bottomSheetFullscreen.value ? 'overflow-y-auto' : 'overflow-hidden']);
    const dropdownItemStyles = computed(() => [...SelectDropdownItem]);
    const noSearchResultsStyles = computed(() => [...SelectNoSearchResults]);
    const loaderStyles = computed(() => [...SelectLoader]);
    // Methods
    function toggle() {
      if (!readonly.value && !props.disabled) {
        const popoverInstance = popover.value;
        if (popoverInstance) {
          if (popoverState.value === 'open' && !focused.value) {
            close();
          } else {
            open();
            setTimeout(() => {
              focus();
            });
          }
        }
      }
    }
    function open() {
      const popoverInstance = popover.value;
      if (popoverInstance) {
        popoverInstance.open();
      }
    }
    function close() {
      const popoverInstance = popover.value;
      if (popoverInstance) {
        popoverInstance.close();
      }
    }
    function focus() {
      if (enableSearch.value) {
        const controlInstance = isMobile.value ? searchControl.value : multiple.value ? multipleControl.value : singleControl.value;
        if (controlInstance) {
          controlInstance.focus();
        }
      }
    }
    function selectOption(value) {
      if (props.multiple) {
        proxyModelValue.value = $s(value, Fs(proxyModelValue.value));
      } else {
        proxyModelValue.value = value;
      }
      searchText.value = '';
    }
    function deselectOption(value) {
      if (props.multiple) {
        proxyModelValue.value = ds(value, Fs(proxyModelValue.value));
      } else {
        proxyModelValue.value = undefined;
      }
    }
    function toggleOption(value) {
      if (props.multiple) {
        const model = Fs(proxyModelValue.value);
        if (!model.includes(value)) {
          proxyModelValue.value = $s(value, model);
        } else {
          proxyModelValue.value = ds(value, model);
        }
      } else {
        proxyModelValue.value = proxyModelValue.value !== value ? value : undefined;
      }
      searchText.value = '';
    }
    // Utils
    const {
      isDesktop,
      isMobile
    } = ne();
    return {
      root,
      inputBox,
      inputBoxRoot,
      control,
      multipleControl,
      singleControl,
      searchControl,
      popover,
      popoverRoot,
      popoverState,
      rootStyles,
      controlStyles,
      searchControlStyles,
      dropdownStyles,
      dropdownContainerStyles,
      dropdownItemStyles,
      noSearchResultsStyles,
      loaderStyles,
      controlId,
      proxyModelValue,
      readonly,
      isEmptyModelValue,
      showClear,
      searchText,
      internalSearchOptions,
      resolvedSearchOptions,
      groupedOptions,
      toggle,
      close,
      open,
      selectOption,
      deselectOption,
      toggleOption,
      isDesktop,
      isMobile
    };
  }
});

const _hoisted_1 = ["id", "disabled"];
const _hoisted_2 = {
  class: /*#__PURE__*/normalizeClass(['layout-inline-row', 'gap-sm'])
};
const _hoisted_3 = {
  key: 0,
  class: /*#__PURE__*/normalizeClass(['px-sm+', 'py-xs'])
};
const _hoisted_4 = ["onClick"];
function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrLabel = resolveComponent("OrLabel");
  const _component_OrSelectMultipleControl = resolveComponent("OrSelectMultipleControl");
  const _component_OrSelectSingleControl = resolveComponent("OrSelectSingleControl");
  const _component_OrIconButton = resolveComponent("OrIconButton");
  const _component_OrIcon = resolveComponent("OrIcon");
  const _component_OrInput = resolveComponent("OrInput");
  const _component_OrLoader = resolveComponent("OrLoader");
  const _component_OrCheckbox = resolveComponent("OrCheckbox");
  const _component_OrMenuItem = resolveComponent("OrMenuItem");
  const _component_OrExpansionPanel = resolveComponent("OrExpansionPanel");
  const _component_OrPopover = resolveComponent("OrPopover");
  const _component_OrInputBox = resolveComponent("OrInputBox");
  const _component_OrHint = resolveComponent("OrHint");
  const _component_OrError = resolveComponent("OrError");
  const _directive_dropdown_open = resolveDirective("dropdown-open");
  const _directive_dropdown_close = resolveDirective("dropdown-close");
  return openBlock(), createElementBlock("div", {
    ref: 'root',
    class: normalizeClass(_ctx.rootStyles)
  }, [_ctx.$slots.label || _ctx.$slots.addon || _ctx.label ? (openBlock(), createBlock(_component_OrLabel, {
    key: 0,
    "control-id": _ctx.controlId,
    variant: 'input',
    required: _ctx.required,
    disabled: _ctx.disabled
  }, {
    addon: withCtx(() => [renderSlot(_ctx.$slots, "addon")]),
    default: withCtx(() => [renderSlot(_ctx.$slots, "label", {}, () => [createTextVNode(toDisplayString(_ctx.label), 1 /* TEXT */)])]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["control-id", "required", "disabled"])) : createCommentVNode("v-if", true), withDirectives((openBlock(), createBlock(_component_OrInputBox, {
    ref: 'inputBox',
    class: normalizeClass([_ctx.popoverState === 'open' && (_ctx.popover && _ctx.popover.isFlipped ? 'rounded-t-0' : 'rounded-b-0'), {
      'outline-none': _ctx.variant === 'embedded'
    }]),
    variant: _ctx.variant,
    size: _ctx.size,
    invalid: !!_ctx.error,
    readonly: _ctx.readonly,
    disabled: _ctx.disabled,
    tabindex: !_ctx.disabled ? 0 : null
  }, {
    default: withCtx(() => [createElementVNode("div", {
      id: _ctx.controlId,
      ref: 'control',
      class: normalizeClass(_ctx.controlStyles),
      disabled: _ctx.disabled,
      onFocus: _cache[3] || (_cache[3] = $event => _ctx.$emit('focus', $event)),
      onBlur: _cache[4] || (_cache[4] = $event => _ctx.$emit('blur', $event))
    }, [renderSlot(_ctx.$slots, "valueTemplate", {
      model: _ctx.proxyModelValue
    }, () => [_ctx.multiple ? (openBlock(), createBlock(_component_OrSelectMultipleControl, {
      key: 0,
      ref: 'multipleControl',
      modelValue: _ctx.searchText,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.searchText = $event),
      model: _ctx.proxyModelValue,
      options: _ctx.options,
      overflow: _ctx.overflow,
      placeholder: _ctx.placeholder,
      readonly: _ctx.readonly,
      disabled: _ctx.disabled,
      "enable-search": _ctx.enableSearch,
      "is-open": _ctx.popoverState === 'open',
      onReset: _cache[1] || (_cache[1] = $event => _ctx.deselectOption($event))
    }, {
      tag: withCtx(({
        item
      }) => [renderSlot(_ctx.$slots, "tag", {
        item: item
      })]),
      _: 3 /* FORWARDED */
    }, 8 /* PROPS */, ["modelValue", "model", "options", "overflow", "placeholder", "readonly", "disabled", "enable-search", "is-open"])) : (openBlock(), createBlock(_component_OrSelectSingleControl, {
      key: 1,
      ref: 'singleControl',
      modelValue: _ctx.searchText,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _ctx.searchText = $event),
      model: _ctx.proxyModelValue,
      options: _ctx.options,
      placeholder: _ctx.placeholder,
      disabled: _ctx.disabled,
      "enable-search": _ctx.enableSearch,
      "is-open": _ctx.popoverState === 'open'
    }, null, 8 /* PROPS */, ["modelValue", "model", "options", "placeholder", "disabled", "enable-search", "is-open"]))])], 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_1), createElementVNode("div", _hoisted_2, [_ctx.showClear ? (openBlock(), createBlock(_component_OrIconButton, {
      key: 0,
      icon: 'close',
      color: 'inherit',
      "additional-styles": ['!text-outline', '!dark:text-outline-dark'],
      disabled: _ctx.readonly || _ctx.disabled,
      onClick: _cache[5] || (_cache[5] = withModifiers($event => _ctx.$emit('update:modelValue', _ctx.multiple ? [] : undefined), ["stop"]))
    }, null, 8 /* PROPS */, ["disabled"])) : createCommentVNode("v-if", true), withDirectives(createVNode(_component_OrIcon, {
      icon: _ctx.popoverState === 'open' ? _ctx.enableSearch ? 'search' : 'arrow_drop_up' : 'arrow_drop_down',
      class: normalizeClass(_ctx.popoverState === 'open' && _ctx.enableSearch ? '!text-outline !dark:text-outline-dark' : ''),
      variant: 'outlined'
    }, null, 8 /* PROPS */, ["icon", "class"]), [[vShow, !(_ctx.popoverState === 'open' && _ctx.enableSearch && _ctx.enableClear && !_ctx.isEmptyModelValue)]])]), createVNode(_component_OrPopover, {
      ref: 'popover',
      class: normalizeClass(_ctx.dropdownStyles),
      "custom-styles": _ctx.dropdownStyles,
      variant: 'auto',
      trigger: _ctx.anchor || _ctx.inputBoxRoot,
      placement: 'bottom',
      offset: 0,
      "full-width": true,
      "disable-default-styles": true
    }, {
      default: withCtx(() => [_ctx.popoverState === 'open' && _ctx.enableSearch && _ctx.isMobile ? (openBlock(), createBlock(_component_OrInput, {
        key: 0,
        ref: 'searchControl',
        modelValue: _ctx.searchText,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => _ctx.searchText = $event),
        class: normalizeClass(_ctx.searchControlStyles),
        type: 'search',
        placeholder: _ctx.placeholder
      }, null, 8 /* PROPS */, ["modelValue", "class", "placeholder"])) : createCommentVNode("v-if", true), createElementVNode("div", {
        class: normalizeClass(_ctx.dropdownContainerStyles)
      }, [_ctx.loading ? (openBlock(), createElementBlock("div", _hoisted_3, [renderSlot(_ctx.$slots, "loading", {}, () => [createVNode(_component_OrLoader, {
        class: normalizeClass(_ctx.loaderStyles),
        variant: "text",
        text: _ctx.loadingText
      }, null, 8 /* PROPS */, ["class", "text"])])])) : _ctx.resolvedSearchOptions.length > 0 ? (openBlock(), createElementBlock(Fragment, {
        key: 1
      }, [_ctx.groupByFunction ? (openBlock(true), createElementBlock(Fragment, {
        key: 0
      }, renderList(_ctx.groupedOptions, (group, groupName) => {
        return openBlock(), createBlock(_component_OrExpansionPanel, {
          key: groupName,
          label: groupName
        }, {
          default: withCtx(() => [_ctx.multiple ? (openBlock(true), createElementBlock(Fragment, {
            key: 0
          }, renderList(group, (option, i) => {
            return openBlock(), createBlock(_component_OrMenuItem, {
              key: i,
              "tooltip-text": option.label,
              selected: _ctx.proxyModelValue && _ctx.proxyModelValue.includes(option.value),
              disabled: option.disabled
            }, {
              default: withCtx(() => [renderSlot(_ctx.$slots, "optionTemplate", {
                model: _ctx.proxyModelValue,
                option: option
              }, () => [createVNode(_component_OrCheckbox, {
                modelValue: _ctx.proxyModelValue,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => _ctx.proxyModelValue = $event),
                value: option.value,
                label: option.label,
                "label-variant": 'menu-item',
                disabled: option.disabled
              }, null, 8 /* PROPS */, ["modelValue", "value", "label", "disabled"])])]),
              _: 2 /* DYNAMIC */
            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["tooltip-text", "selected", "disabled"]);
          }), 128 /* KEYED_FRAGMENT */)) : (openBlock(true), createElementBlock(Fragment, {
            key: 1
          }, renderList(group, (option, i) => {
            return openBlock(), createBlock(_component_OrMenuItem, {
              key: i,
              class: normalizeClass(_ctx.dropdownItemStyles),
              "tooltip-text": option.label,
              selected: _ctx.proxyModelValue === option.value,
              disabled: option.disabled,
              onClick: withModifiers($event => _ctx.selectOption(option.value), ["stop"])
            }, {
              default: withCtx(() => [renderSlot(_ctx.$slots, "optionTemplate", {
                model: _ctx.proxyModelValue,
                option: option
              }, () => [createTextVNode(toDisplayString(option.label), 1 /* TEXT */)])]),
              _: 2 /* DYNAMIC */
            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["class", "tooltip-text", "selected", "disabled", "onClick"]);
          }), 128 /* KEYED_FRAGMENT */))]),
          _: 2 /* DYNAMIC */
        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["label"]);
      }), 128 /* KEYED_FRAGMENT */)) : (openBlock(), createElementBlock(Fragment, {
        key: 1
      }, [_ctx.multiple ? (openBlock(true), createElementBlock(Fragment, {
        key: 0
      }, renderList(_ctx.resolvedSearchOptions, (option, i) => {
        return openBlock(), createBlock(_component_OrMenuItem, {
          key: i,
          "tooltip-text": option.label,
          class: normalizeClass(_ctx.dropdownItemStyles),
          selected: _ctx.proxyModelValue && _ctx.proxyModelValue.includes(option.value),
          disabled: option.disabled,
          onClick: withModifiers($event => !option.disabled && _ctx.toggleOption(option.value), ["stop"])
        }, {
          default: withCtx(() => [createVNode(_component_OrCheckbox, {
            "model-value": _ctx.proxyModelValue,
            value: option.value,
            "label-variant": 'menu-item',
            disabled: option.disabled
          }, {
            default: withCtx(() => [createElementVNode("div", {
              onClick: $event => !option.disabled && _ctx.toggleOption(option.value)
            }, [renderSlot(_ctx.$slots, "optionTemplate", {
              model: _ctx.proxyModelValue,
              option: option
            }, () => [createTextVNode(toDisplayString(option.label), 1 /* TEXT */)])], 8 /* PROPS */, _hoisted_4)]),
            _: 2 /* DYNAMIC */
          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["model-value", "value", "disabled"])]),
          _: 2 /* DYNAMIC */
        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["tooltip-text", "class", "selected", "disabled", "onClick"]);
      }), 128 /* KEYED_FRAGMENT */)) : (openBlock(true), createElementBlock(Fragment, {
        key: 1
      }, renderList(_ctx.resolvedSearchOptions, (option, i) => {
        return openBlock(), createBlock(_component_OrMenuItem, {
          key: i,
          class: normalizeClass(_ctx.dropdownItemStyles),
          selected: _ctx.proxyModelValue === option.value,
          "tooltip-text": option.label,
          disabled: option.disabled,
          onClick: withModifiers($event => {
            _ctx.selectOption(option.value);
            _ctx.close();
          }, ["stop"])
        }, {
          default: withCtx(() => [renderSlot(_ctx.$slots, "optionTemplate", {
            model: _ctx.proxyModelValue,
            option: option
          }, () => [createTextVNode(toDisplayString(option.label), 1 /* TEXT */)])]),
          _: 2 /* DYNAMIC */
        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["class", "selected", "tooltip-text", "disabled", "onClick"]);
      }), 128 /* KEYED_FRAGMENT */))], 64 /* STABLE_FRAGMENT */))], 64 /* STABLE_FRAGMENT */)) : (openBlock(), createElementBlock("div", {
        key: 2,
        class: normalizeClass(_ctx.noSearchResultsStyles)
      }, [renderSlot(_ctx.$slots, "noSearchResultsTemplate", {
        searchText: _ctx.searchText
      }, () => [createTextVNode(" No results ")])], 2 /* CLASS */))], 2 /* CLASS */)]),
      _: 3 /* FORWARDED */
    }, 8 /* PROPS */, ["class", "custom-styles", "trigger"])]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["class", "variant", "size", "invalid", "readonly", "disabled", "tabindex"])), [[_directive_dropdown_open, _ctx.toggle], [_directive_dropdown_close, _ctx.close]]), _ctx.$slots.hint || _ctx.hint ? withDirectives((openBlock(), createBlock(_component_OrHint, {
    key: 1,
    disabled: _ctx.disabled
  }, {
    default: withCtx(() => [renderSlot(_ctx.$slots, "hint", {}, () => [createTextVNode(toDisplayString(_ctx.hint), 1 /* TEXT */)])]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["disabled"])), [[vShow, !_ctx.error]]) : createCommentVNode("v-if", true), withDirectives(createVNode(_component_OrError, {
    disabled: _ctx.disabled
  }, {
    default: withCtx(() => [createTextVNode(toDisplayString(_ctx.error), 1 /* TEXT */)]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["disabled"]), [[vShow, typeof _ctx.error === 'string' && _ctx.error.length > 0]])], 2 /* CLASS */);
}

script.render = render;
script.__file = "src/components/or-select-v3/OrSelect.vue";

export { script as OrSelectV3 };
